import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class TransactionHistoryIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} viewBox="0 0 24 24" >
            <g fill="currentColor">
                <path d="M17.333,18.68V9.333h-2.667v9.347h-4L16,24l5.334-5.32H17.333z M8,0L2.666,5.32h4v9.347h2.665V5.32h4.001L8,0z"/>
            </g>
        </SvgIcon>;
    }
}
